import { $subscriber, interact } from "fire-wind-water";
import settingPc from "@/sktempjson/exam-random-pc.json";
import settingWap from "@/sktempjson/exam-random-wap.json";
import { $extras, $messageLoad } from "@/../stempcore/src/core/sextra.js";
import { URLS } from "fire-wind-water/index";
import Api from "../service/api";

let templateMixin = {
  data() {
    return {
      extras: {},
      isSetting: Number(URLS.getURL("isSetting")),
    };
  },
  created() {
    console.log("# subscribe 'sk-template-config'.");
    $subscriber.subscribe("sk-template-config", (o) => {
      console.log("# catch 'sk-template-config' ...");
      // console.log("# o.data: ", JSON.stringify(o.data));
      this.extras = $extras(o.data).extras;
      if (this.extras.themecolor && this.extras.themecolor.bgcolor) {
        let themeColorClear = "";
        const rgbaAttr = this.extras.themecolor.bgcolor.match(/[\d.]+/g);
        if (rgbaAttr.length >= 3) {
          let r, g, b;
          r = rgbaAttr[0];
          g = rgbaAttr[1];
          b = rgbaAttr[2];
          themeColorClear = "rgba(" + r + "," + g + "," + b + "," + 0.2 + ")";
        }

        document.body.style.setProperty(
          "--themeColor",
          this.extras.themecolor.bgcolor
        );
        document.body.style.setProperty("--themeColorClear", themeColorClear);
      }
    });
  },
  mounted() {
    console.log("# $messageLoad ...");
    $messageLoad(1);
  },
  methods: {
    initConfig(configId, tenantId) {
      if (this.isSetting) {
        // if (process.env.NODE_ENV === "development") {
        this.extras = $extras(
          interact.isMobile ? settingWap.html : settingPc.html
        ).extras;
        // }
        return;
      }
      Api.getTemplateConfig({
        tenantId: tenantId,
        configId: configId,
      }).subscribe((res) => {
        this.extras = $extras(res.content.info.html).extras;
        if (this.extras.themecolor && this.extras.themecolor.bgcolor) {
          let themeColorClear = "";
          const rgbaAttr = this.extras.themecolor.bgcolor.match(/[\d.]+/g);
          if (rgbaAttr.length >= 3) {
            let r, g, b;
            r = rgbaAttr[0];
            g = rgbaAttr[1];
            b = rgbaAttr[2];
            themeColorClear = "rgba(" + r + "," + g + "," + b + "," + 0.2 + ")";
          }

          document.body.style.setProperty(
            "--themeColor",
            this.extras.themecolor.bgcolor
          );
          document.body.style.setProperty("--themeColorClear", themeColorClear);
        }
      });
    },
  },
};

export default templateMixin;
